import React from 'react';

const NotAvailablePage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <h2>Страница недоступна</h2>
      <p>У вас нет доступа к данной странице.</p>
    </div>
  );
};

export default NotAvailablePage;
